// extracted by mini-css-extract-plugin
export default {"analog_clock_container":"analog-clock_analog_clock_container__rz9Uo"};